import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintDeployment } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const TemplateDeploymentsVersionCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<BlueprintDeployment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={deployment.blueprintVersion?.version} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsVersionCell;
